import React, { Component } from 'react'
import { object, func } from 'prop-types'
import { connect } from 'react-redux'

import styles from './ResultsPage.styl'
import { HorizontalBarChart, Chart, Loading } from '../../components'
import { fetchAction } from '../../../../store/actions/fetchAction'


const optionsTranslate = {
	'Distância': 'distance',
	'Tempo': 'time',
	'FC Média': 'averageBPM',
	'Velocidade': 'averageSpeed',
	'Calorias': 'calories',
	'Eficiência': 'ZIUT',
	'Dificuldade': 'difficulty',
	'Resiliência': 'resilience',
	'Rendimento': 'yield'
}

class Results extends Component {

	static propTypes = {
		fetchResults: object,
		dispatch: func
	}

	constructor(props) {
		super(props)
		const { fetchResults, dispatch } = props
		const graphData = fetchResults['graphData']
		dispatch(fetchAction(`/api/athletes/graph_data`, ['FETCH_QUERIES_START', 'FETCH_QUERIES_SUCCESS', 'FETCH_QUERIES_REJECT'], { fetchUrl: 'graphData' }))
		dispatch(fetchAction(`/api/workout_zones`, ['FETCH_QUERIES_START', 'FETCH_QUERIES_SUCCESS', 'FETCH_QUERIES_REJECT'], { fetchUrl: 'goals' }))
		if (graphData) {
			const resultData = this.handleResultData(graphData, 1, 0, { name: 'Todos' })
			this.state = { ...resultData, selectOptions: { from: 1, to: 0, goal: { name: 'Todos' }, option: 'Distância' } }
		} else { this.state = { resultData: null, selectOptions: { from: 1, to: 0, goal: { name: 'Todos' }, option: 'Distância' } } }
	}

	componentWillReceiveProps(nextProps) {
		const { fetchResults } = nextProps
		const graphData = fetchResults['graphData']
		if (graphData) { this.setState(this.handleResultData(graphData, 1, 0, { name: 'Todos' })) }
	}
	reduceWeek(workouts, goal, ldDistance, ldTime, ldDA, ldDP) {
		const reducedWorkouts = workouts.reduce((sum, ele) => {
			if (goal.id && goal.id !== ele.goalId) { return sum }
			for (const [key, value] of Object.entries(ele.currentParams)) {
				if (!sum[key]) { sum[key] = {} }
				if (key === 'distance' || key === 'time') {
					if (sum[key] && sum[key].current) { sum[key].current += parseFloat(value) } else { sum[key].current = parseFloat(value) }
				} else if (sum[key] && sum[key].current) { sum[key].current.push(parseFloat(value)) } else { sum[key].current = [parseFloat(value)] }
			}
			if (ele.athleteParams) {
				for (const [key, value] of Object.entries(ele.athleteParams)) {
					if (!sum[key]) { sum[key] = {} }
					if (key === 'distance' || key === 'time') {
						if (sum[key] && sum[key].athlete) { sum[key].athlete += parseFloat(value) } else { sum[key].athlete = parseFloat(value) }
					} else if (sum[key] && sum[key].athlete) { sum[key].athlete.push(parseFloat(value)) } else { sum[key].athlete = [parseFloat(value)] }
				}
				if (ele.goalId === '083c697a-1297-4d60-a004-237538b22c1d') {
					ldDistance.push(ele.athleteParams.distance)
					ldTime.push(ele.athleteParams.time)
					ldDA.push(ele.athleteParams.DA)
					ldDP.push(ele.athleteParams.DP)
				}
			}
			if (ele.coefficients) {
				for (const [k, v] of Object.entries(ele.coefficients)) {
					sum.coefficients[k].push(v)
				}
			}
			return sum
		}, { coefficients: { ZIUT: [], yield: [], difficulty: [], resilience: [] } })
		for (const [key, value] of Object.entries(reducedWorkouts)) {
			if (key !== 'distance' && key !== 'time' && key !== 'coefficients') {
				for (const [k, v] of Object.entries(value.athlete ? value : { ...value, athlete: [] })) {
					reducedWorkouts[key][k] = (v.reduce((s, e) => s + e, 0) / v.length) || 0
				}
			}
		}
		return reducedWorkouts
	}
	handleResultData(graphData, from, to, goal) {
		const graphArray = []
		const ldDistance = []
		const ldTime = []
		const ldDA = []
		const ldDP = []
		const resultData = graphData.slice(to, from + 1).reduce((sum1, week) => {
			const { distance, time } = sum1
			const processedWorkout = this.reduceWeek(week.workouts, goal, ldDistance, ldTime, ldDA, ldDP)
			graphArray.push({
				data: {
					...processedWorkout,
					coefficients: undefined,
					...(() => {
						const obj = {}
						for (const [k, v] of Object.entries(processedWorkout.coefficients)) {
							obj[k] = { athlete: (v.reduce((s, e) => s + e * 100, 0) / v.length) || 0 }
						}
						return obj
					})()
				},
				weekYear: week.weekYear
			})
			distance.athlete += (processedWorkout.distance || {}).athlete || 0
			distance.current += (processedWorkout.distance || {}).current || 0
			time.athlete += (processedWorkout.time || {}).athlete || 0
			time.current += (processedWorkout.time || {}).current || 0
			return { distance, time }
		}, { distance: { athlete: 0, current: 0 }, time: { athlete: 0, current: 0 } })

		const distanceLd = (ldDistance.reduce((sum, ele) => sum + ele, 0) / ldDistance.length) || 0
		const timeLd = (ldTime.reduce((sum, ele) => sum + ele, 0) / ldTime.length) || 0
		const DALd = (ldDA.reduce((sum, ele) => sum + ele, 0) / ldDA.length) || 0
		const DPLd = (ldDP.reduce((sum, ele) => sum + ele, 0) / ldDP.length) || 0
		return {
			resultData,
			graphArray,
			distanceLd,
			timeLd,
			DPLd,
			DALd
		}
	}

	calcPace(velocity) {
		let min = 60 / velocity
		let hour = '00'
		if (min > 60) {
			hour = min / 60
			min = Math.round((hour - Math.floor(hour)) * 60)
			hour = Math.floor(hour)
		}
		let sec = Math.round((min - Math.floor(min)) * 60)
		if (sec < 10) { sec = `0${ sec }` }
		min = Math.floor(min)
		if (min < 10) { min = `0${ min }` }
		return `${ hour }:${ min }:${ sec }`
	}

	handleSelectChange(to, from, goal) {
		const { fetchResults } = this.props
		const graphData = fetchResults['graphData']
		const challenge = fetchResults['challenge']
		if (from < to) { to = from }
		const resultData = this.handleResultData(graphData, from, to, goal, challenge)
		this.setState(prevState => ({ selectOptions: { ...prevState.selectOptions, from, to }, ...resultData }))
	}

	createSelectOptions() {
		const { resultData, selectOptions: { from, to, goal, option } } = this.state
		const { fetchResults } = this.props
		const graphData = fetchResults['graphData']
		const challenge = fetchResults['challenge']
		const goals = fetchResults['goals']
		if (!resultData) { return null }

		const optionFrom = graphData.map((ele, i) => (<option key={ i } value={ i + 1 }>{ `Microciclo ${ ele.weekYear }` }</option>))
		const optionTo = graphData.slice(0, from + 1).map((ele, i) => (<option key={ i } value={ i + 1 }>{ `Microciclo ${ ele.weekYear }` }</option>))
		const optionZone = [{ name: 'Todos' }, ...goals].map((ele, i) => (<option key={ i } value={ JSON.stringify({ id: ele.id, name: ele.name }) }>{ ele.name }</option>))
		const optionOptions = ['Distância', 'Tempo', 'FC Média', 'Velocidade', 'Calorias', 'Eficiência', 'Dificuldade', 'Resiliência', 'Rendimento'].map((ele, i) => (<option key={ i } value={ ele }>{ ele }</option>))

		return (
			<div className={ styles['select-container'] }>
				<div>
					<label>Inicio:</label>
					<select value={ from + 1 } onChange={ (e) => { this.handleSelectChange(to, parseInt(e.target.value - 1, 10), goal, challenge) } }>{ optionFrom }</select>
				</div>
				<div>
					<label>Fim:</label>
					<select value={ to + 1 } onChange={ (e) => { this.handleSelectChange(parseInt(e.target.value - 1, 10), from, goal, challenge) } }>{ optionTo }</select>
				</div>
				<div>
					<label>Zona:</label>
					<select
						value={ JSON.stringify(goal) } onChange={ (e) => {
							const a = JSON.parse(e.target.value)
							const results = this.handleResultData(graphData, from, to, a, challenge)
							this.setState(prevState => ({ ...results, selectOptions: { ...prevState.selectOptions, goal: a } }))
						} }
					>{ optionZone }</select>
				</div>
				<div>
					<label>Opções:</label>
					<select
						value={ option } onChange={ (e) => {
							const value = e.target.value
							this.setState(prevState => ({ selectOptions: { ...prevState.selectOptions, option: value } }))
						} }
					>{ optionOptions }</select>
				</div>
			</div >
		)
	}

	renderChallengeComparator() {
		const { distanceLd, timeLd, DALd, DPLd } = this.state
		const { fetchResults } = this.props
		const challenge = fetchResults['challenge']
		const { distance, time, DA, DP } = challenge

		const challengeCoefficient = distance + 0.00000012 * DP ^ 2 + 0.00572 * DP + 0.00000012 * (DA - DP) ^ 2 + 0.0005 * (DA - DP)
		const ldCoefficient = distanceLd + 0.00000012 * DPLd ^ 2 + 0.00572 * DPLd + 0.00000012 * (DALd - DPLd) ^ 2 + 0.0005 * (DALd - DPLd)
		const finalValue = Math.round(ldCoefficient * 100 / challengeCoefficient)
		const velocity = distanceLd / (timeLd / 60)

		return (
			<div className={ styles['speed-graph-container'] }>
				<div>
					<h2>{ challenge.name }</h2>
					<h4>PACE / VELOCIDADE / RENDIMENTO</h4>
				</div>
				<div className={ styles['speed-graphs'] }>
					{/* <div>
						<SpeedGraph width="300px" height="150px" percentage={ velocity * 100 / (distance / (time / 60)) } title="PACE / VELOCIDADE " isNormal={ false } />
					</div>
					<div>
						<SpeedGraph width="300px" height="150px" percentage={ finalValue > 100 ? 100 : finalValue } title="RENDIMENTO " isNormal />
					</div> */}
				</div>
			</div>
		)
	}

	render() {
		const { resultData, selectOptions: { option, goal }, graphArray } = this.state
		const { fetchResults } = this.props
		const graphData = fetchResults['graphData']
		const challenge = fetchResults['challenge']
		const goals = fetchResults['goals']
		if (!graphData || !goals) { return <Loading /> }
		return (
			<div>
				<div className={ styles['content'] }>
					{ this.createSelectOptions() }
					{ challenge && Object.keys(challenge).length ? this.renderChallengeComparator() : null }
					<div className={ styles['chart-container'] }>
						<Chart value={ graphArray } optionKey={ optionsTranslate[option] } challenge={ challenge } isLD={ goal.name === 'LD' && challenge && Object.keys(challenge).length > 0 } />
					</div>
					<div className={ styles['horizontal-bar'] }>
						<HorizontalBarChart title="Distância" value={ resultData ? resultData.distance : { assigned: 1, current: 0 } } />
						<HorizontalBarChart title="Tempo" value={ resultData ? resultData.time : { assigned: 1, current: 0 } } />
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	fetchResults: state.fetch.results
})


export default connect(mapStateToProps)(Results)



// WEBPACK FOOTER //
// ./src/client/webapp/pages/ResultsPage/ResultsPage.js